<template>
  <div class="clients">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Agent</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Agent</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_client">
                  <i class="fa fa-plus"></i> Add Agent
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="fieldsGetAgentList.email"
                  type="text"
                  class="form-control floating"
                  @change="getAgentList"
                />
                <label class="focus-label">Email</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="fieldsGetAgentList.name"
                  type="text"
                  class="form-control floating"
                  @change="getAgentList"
                />
                <label class="focus-label">Name</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click="getAgentList"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <!-- Search Filter -->
          <div v-if="!!loading" class="row staff-grid-row">
            <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3">
              <div class="profile-widget">
                <Skeleton :count="3" />
              </div>
            </div>
          </div>
          <div v-if="listData.length>0" class="row staff-grid-row">
            <div
              :ref="'ref-'+rowArr.id"
              v-for="(rowArr,index) in listData"
              :key="index"
              class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
            >
              <div class="profile-widget">
                <div class="dropdown profile-action">
                  <a
                    href="#"
                    class="action-icon dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      href="#"
                      data-toggle="modal"
                      data-target="#edit_client"
                      @click="getAgentById(rowArr.id)"
                    >
                      <i class="fa fa-pencil m-r-5"></i> Profile
                    </a>
                    <a
                      class="dropdown-item"
                      href="#"
                      data-toggle="modal"
                      data-target="#edit_client_password"
                      @click="getAgentById(rowArr.id)"
                    >
                      <i class="fa fa-key m-r-5"></i>Set Password
                    </a>
                  </div>
                </div>
                <h4
                  class="user-name m-t-10 mb-0 text-ellipsis"
                >{{rowArr.first_name}} {{rowArr.last_name}}</h4>
                <h5 class="user-name m-t-10 mb-0 text-ellipsis">{{rowArr.email}}</h5>
                <router-link
                  :to="'/agent/monthly_agents_statistics?agent_id='+rowArr.id"
                  class="btn btn-white btn-sm m-t-10"
                >Performance</router-link>
                <router-link
                  :to="'/agent/roles?id='+rowArr.id"
                  class="btn btn-white btn-sm m-t-10"
                >Roles</router-link>
              </div>
            </div>
          </div>
          <div class="row staff-grid-row" v-else>
            <div class="col-md-12 col-sm-12 col-12 col-lg-12 col-xl-12">
              <div class="profile-widget">
                There is no data
                <hr />
                <a href="#" data-toggle="modal" data-target="#add_client">
                  <i class="fa fa-plus"></i> Add Agent
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- Add Client Modal -->
        <div id="add_client" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Agent</h5>
                <button
                  id="btnCloseCreateLicense"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="createStored" class="was-validated">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          Email
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          v-model="formCreate.email"
                          class="form-control"
                          type="email"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          First Name
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          v-model="formCreate.first_name"
                          class="form-control"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">Last Name</label>
                        <input
                          placeholder="Optional"
                          v-model="formCreate.last_name"
                          class="form-control"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Client Modal -->

        <!-- edit client -->
        <div id="edit_client" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Update Profile</h5>
                <button
                  id="btnCloseUpdateLicense"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updateStored" class="was-validated">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          Email
                          <span class="text-danger">*</span>
                        </label>
                        <input v-model="formUpdate.id" class="form-control" type="hidden" required />
                        <input
                          v-model="formUpdate.email"
                          class="form-control"
                          type="email"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          First Name
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          v-model="formUpdate.first_name"
                          class="form-control"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">Last Name</label>
                        <input v-model="formUpdate.last_name" class="form-control" type="text" />
                      </div>
                    </div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /edit client -->
        <!-- edit password -->
        <div id="edit_client_password" class="modal custom-modal fade" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Update Password</h5>
                <button
                  id="btnCloseUpdatePassword"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="updatePasswordStored" class="was-validated">
                  <span>
                    <i class="fa fa-envelope"></i>
                    {{formUpdatePassword.email}}
                  </span>

                  <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          New Password
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          v-model="formUpdatePassword.id"
                          class="form-control"
                          type="hidden"
                          required
                        />
                        <input
                          v-model="formUpdatePassword.new_password"
                          class="form-control"
                          type="password"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-3"></div>
                    <div class="col-md-3"></div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">
                          Owner Password [For Confirmation]
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          v-model="formUpdatePassword.member_password"
                          class="form-control"
                          type="password"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-3"></div>
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      loading: false,
      listData: [],
      formCreate: {
        email: "",
        first_name: "",
        last_name: ""
      },
      formUpdate: {
        id: "",
        email: "",
        first_name: "",
        last_name: ""
      },
      formUpdatePassword: {
        id: "",
        new_password: "",
        member_password: ""
      }
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["fieldsGetAgentList"])
  },
  async created() {
    this.getAgentList();
  },
  methods: {
    async updatePasswordStored() {
      // this.loading = await true;
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("agent/updatePasswordStored", this.formUpdatePassword)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(async r => {
                await document.getElementById("btnCloseUpdatePassword").click(); // Click on the checkbox
                this.formUpdatePassword = {
                  id: "",
                  new_password: "",
                  member_password: ""
                };
                await this.getAgentList();
              });
            });
        }
      });

      // this.loading = await false;
    },
    async getAgentById(id) {
      this.loading = await true;

      await this.$store.dispatch("agent/getAgentById", id).then(response => {
        var { data } = response;
        this.formUpdate = data;
        this.formUpdatePassword = data;
        //   console.log("response", response);
      });
      this.loading = await false;
    },
    async getAgentList() {
      this.loading = await true;

      await this.$store
        .dispatch("agent/getAgentList", this.fieldsGetAgentList)
        .then(response => {
          var { data } = response;
          this.listData = data.data;
          //   console.log("response", response);
        });
      this.loading = await false;
    },
    async updateStored() {
      // this.loading = await true;
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("agent/updateStored", this.formUpdate)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(async r => {
                await document.getElementById("btnCloseUpdateLicense").click(); // Click on the checkbox
                this.fieldsGetAgentList.email = await this.formUpdate.email;
                await this.getAgentList();
              });
            });
        }
      });

      // this.loading = await false;
    },
    async createStored() {
      this.loading = await true;
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("agent/createStored", this.formCreate)
            .then(response => {
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 3000
              }).then(async r => {
                await document.getElementById("btnCloseCreateLicense").click(); // Click on the checkbox
                await this.getAgentList();
                this.formCreate = {
                  email: "",
                  first_name: "",
                  last_name: ""
                };
              });
            });
        }
      });

      this.loading = await false;
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "clients"
};
</script>


// WEBPACK FOOTER //
// src/views/agent/list.vue